<div class="modal-header">
  <h4 class="modal-title">
    <i class="fa" [class.fa-android]="!isCopy" [class.fa-copy]="isCopy"></i>
    <ng-container *ngIf="!isCopy">Criar agente para {{ account?.name || 'este número' }}</ng-container>
    <ng-container *ngIf="isCopy">Copiar agente</ng-container>
    <span class="sub">{{ isCopy ? source?.name : 'atalho da sequência' }}</span>
  </h4>
  <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="activeModal.dismiss('close')"
          data-testid="quick-agent-close">
    <i class="fa fa-times"></i>
  </button>
</div>

<div class="modal-body">
  <div class="notice notice--violet notice--sm" *ngIf="!isCopy">
    <i class="fa fa-magic"></i>
    <div class="notice__body"><span>Atalho: o agente nasce já ligado ao número <strong>{{ account?.name }}</strong>. Depois você pode refinar em IA → Meus Agentes.</span></div>
  </div>
  <div class="notice notice--violet notice--sm" *ngIf="isCopy" data-testid="quick-agent-copy-notice">
    <i class="fa fa-copy"></i>
    <div class="notice__body"><span>Cópia de <strong>{{ source?.name }}</strong>: prompt, modelo, eventos e ofertas vêm do original; as listas vinculadas, não. <strong>Nada é criado até você confirmar.</strong></span></div>
  </div>

  <div class="notice notice--danger notice--sm" *ngIf="error" data-testid="quick-agent-error">
    <i class="fa fa-exclamation-triangle"></i>
    <div class="notice__body"><span>{{ error }}</span></div>
  </div>

  <div class="qa-grid">
    <div class="qa-form">
      <div class="field">
        <label for="qa-name">Nome do agente</label>
        <input id="qa-name" class="form-control" [class.is-invalid]="attempted && !name.trim()" [(ngModel)]="name" maxlength="100"
               placeholder="Ex.: Atendente Carrinho" data-testid="quick-agent-name" />
        <span class="field-error" *ngIf="attempted && !name.trim()">Preencha o nome do agente</span>
      </div>

      <div class="field">
        <label for="qa-model">Modelo de IA</label>
        <select id="qa-model" class="form-select" [(ngModel)]="modelId" data-testid="quick-agent-model">
          <option value="">{{ isCopy ? 'O mesmo do original' : 'Selecione o modelo' }}</option>
          <option *ngFor="let m of catalog" [value]="m.id">{{ m.display_name }}</option>
        </select>
        <span class="field-hint" *ngIf="modelDescription">{{ modelDescription }}</span>
        <span class="field-error" *ngIf="attempted && !isCopy && !modelId">Selecione o modelo</span>
      </div>

      <div class="field">
        <label for="qa-prompt">Prompt base</label>
        <textarea id="qa-prompt" class="form-control" rows="7" [class.is-invalid]="attempted && !prompt.trim()" [(ngModel)]="prompt"
                  placeholder="Você é a atendente da loja. Ajude o cliente a finalizar a compra…" data-testid="quick-agent-prompt"></textarea>
        <span class="field-hint">Teste ao lado antes de {{ isCopy ? 'criar a cópia' : 'criar' }}: a conversa usa o que está no formulário agora.</span>
        <span class="field-error" *ngIf="attempted && !prompt.trim()">Preencha o prompt base do agente</span>
      </div>

      <p class="field-hint" *ngIf="isCopy" data-testid="quick-agent-copy-number">
        <i class="fa fa-whatsapp"></i>
        {{ accountName ? 'Responde pelo número ' + accountName + ', como o original.' : 'Sem número fixo, como o original: responde pelo número de cada automação.' }}
      </p>

      <div class="field" *ngIf="canChooseActive">
        <app-switcher id="qa-active" label="Ativar a cópia ao criar" display="block" [(checked)]="active"
                      data-testid="quick-agent-active"></app-switcher>
      </div>
    </div>

    <div class="qa-test" data-testid="quick-agent-test">
      <app-agent-test-panel [draft]="draft" [draftHint]="draftHint" [compact]="true"></app-agent-test-panel>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="sf-btn sf-btn--secondary" (click)="activeModal.dismiss('cancel')" data-testid="quick-agent-cancel">Cancelar</button>
  <button type="button" class="sf-btn sf-btn--primary" (click)="save()" [appLoadingButton]="saving" data-testid="quick-agent-save">
    <i class="fa fa-check"></i>
    {{ isCopy ? (context === 'step' ? 'Criar cópia e selecionar' : 'Criar cópia') : 'Criar e selecionar' }}
  </button>
</div>
